<template>
  <ProfileTabs>
    <RouterView />
  </ProfileTabs>
</template>

<script lang="ts" setup>
import ProfileTabs from '@/components/deepadmin/profile/ProfileTabs.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_account.title',
  },
})
</script>
